import { render, staticRenderFns } from "./EmployeeOccupationTitle.vue?vue&type=template&id=2bfa1af3&"
import script from "./EmployeeOccupationTitle.vue?vue&type=script&lang=js&"
export * from "./EmployeeOccupationTitle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports